__turbopack_context__.v({
  "btn": "InstagramBlock-module__-6xkea__btn",
  "container": "InstagramBlock-module__-6xkea__container",
  "fadeInItems": "InstagramBlock-module__-6xkea__fadeInItems",
  "img": "InstagramBlock-module__-6xkea__img",
  "imgWrapper": "InstagramBlock-module__-6xkea__imgWrapper",
  "link": "InstagramBlock-module__-6xkea__link",
  "overlay": "InstagramBlock-module__-6xkea__overlay",
  "overlayCloseBtn": "InstagramBlock-module__-6xkea__overlayCloseBtn",
  "overlayLink": "InstagramBlock-module__-6xkea__overlayLink",
  "posts": "InstagramBlock-module__-6xkea__posts",
  "postsMobile": "InstagramBlock-module__-6xkea__postsMobile",
  "slider": "InstagramBlock-module__-6xkea__slider",
  "spacing--lg": "InstagramBlock-module__-6xkea__spacing--lg",
  "spacing--md": "InstagramBlock-module__-6xkea__spacing--md",
  "spacing--sm": "InstagramBlock-module__-6xkea__spacing--sm",
  "spacing--xl": "InstagramBlock-module__-6xkea__spacing--xl",
  "spacing--xs": "InstagramBlock-module__-6xkea__spacing--xs",
  "spacing--xxl": "InstagramBlock-module__-6xkea__spacing--xxl",
  "spacing--xxs": "InstagramBlock-module__-6xkea__spacing--xxs",
  "spacing--xxxl": "InstagramBlock-module__-6xkea__spacing--xxxl",
  "spacing--xxxs": "InstagramBlock-module__-6xkea__spacing--xxxs",
  "title": "InstagramBlock-module__-6xkea__title",
});
